import {
	DrawerContentComponentProps,
	DrawerContentOptions,
} from '@react-navigation/drawer';
import React from 'react';
import { StyleSheet, View, TouchableHighlight } from 'react-native';
import colors from '../../../config/colors';
import Typography from '../Typography/Typography.component';
import ImageIcon from '../Icon/ImageIcon.component';

interface DrawerItemProps {
	routeName: string;
	isActive: boolean;
	index: number;
	onPress: (routeName: string) => void;
	/** Overrides the default blue active background for section-specific theming */
	activeColor?: string;
	/** If provided, renders an icon *instead* of the text label */
	logo?: string;
}

const DrawerItem = ({
	routeName,
	isActive,
	index,
	onPress,
	activeColor,
	logo,
}: DrawerItemProps) => {
	const containerStyle = StyleSheet.flatten([
		styles.route,
		isActive
			? {
					...styles.selectedRoute,
					backgroundColor: activeColor ?? colors.titlePrimary,
				}
			: {},
	]);

	return (
		<TouchableHighlight
			underlayColor='transparent'
			onPress={() => onPress(routeName)}
		>
			<View key={index} style={containerStyle}>
				{logo ? (
					<View style={{ alignItems: 'flex-end', justifyContent: 'center', flex: 1 }}>
						<ImageIcon name={logo} width={108} height={30} />
					</View>
				) : (
					<Typography
						style={{ textAlign: 'right' }}
						color={isActive ? 'white' : colors.primaryDarkBlue}
						weight={isActive ? 'normal' : '400'}
						font='medium'
						size={14}
					>
						{routeName}
					</Typography>
				)}
			</View>
		</TouchableHighlight>
	);
};

const styles = StyleSheet.create({
	route: {
		position: 'relative',
		width: '100%',
		// marginLeft: 12,
		height: 50,
		justifyContent: 'center',
		paddingRight: 18,
		borderTopLeftRadius: 50,
		borderBottomLeftRadius: 50,
	},
	selectedRoute: {
		backgroundColor: colors.primary,
	},
});

export default DrawerItem;
